import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment';
import 'moment-duration-format';
import { AuthContext } from '../../store/auth-context';
import sentimentIcon from '../../assets/images/sentiment-icon.svg';
import sentimentIconActive from '../../assets/images/sentiment-icon-active.svg';
import keymomentsIcon from '../../assets/images/keymoments-icon.svg';
import keymomentsIconActive from '../../assets/images/keymoments-icon-active.svg';
import searchIcon from '../../assets/images/search-icon.svg';
import styles from './Media.module.css'
import { randomColor } from '../../constants';
import Linkify from 'linkify-react';
import escapeStringRegexp from 'escape-string-regexp';


const Transcript = (props: any) => {
    const authCtx = useContext(AuthContext)

    const [searchParams, setSearchParams] = useSearchParams()

    const [keywords, setKeywords] = useState<Array<string>>([])
    const [sentimentsAction, setSentimentsAction] = useState(false)
    const [keyMomentsAction, setKeyMomentsAction] = useState(false)
    const [searchedInTranscript, setSearchedInTranscript] = useState('')
    const [activeSearchBar, setActiveSearchBar] = useState(false)
    const [keyMomentsKeyIndex, setKeyMomentsKeyIndex] = useState<{[key: string]: any}>({})
    const [keyMomentsLabels, setKeyMomentsLabels] = useState<{[key: string]: any}>({})

    let totalSentimentsCount = props.totalSentiments.positiveSentiments + props.totalSentiments.negativeSentiments

    useEffect(() => {
        if(searchParams) {
            let words = searchParams.get('keywords')
            if(words) {
                setKeywords(words.split(','))
            } 
        }
    }, [searchParams])

    useEffect(() => {
        getKeyMomentsKeyAndItsIndex()
    }, [])

    /** 
     * keymoment_text as Key and Its object Index as its value
     * 
     * keymoments object from AI eg:
     *  Input :
     *  [{
            "count": 2,
            "keymoment_text": [
                "Thank you for calling Essence.",
                "This is Amira"
            ],
            "label": "introduction",
            "time": [
                425625,
                537183
            ]
        },
        {
            "count": 1,
            "keymoment_text": [
                "Oh, that's the tracking sorry",
            ],
            "label": "tracking/order",
            "time": [
                425625,
                537183
            ]
        }]

        output:
     * 
     *   {
     *      Thank you for calling Essence. : 0,
     *      This is Amira : 0
     *      Oh, that's the tracking sorry: 1
     *   }
     *   
     *   Object: Each label will have its own colour for its keymoment_text, so index will help in achieving that
     * 
     * */ 
    const getKeyMomentsKeyAndItsIndex = () => {
        let keyIsMomentValueisIndex: any = {}
        let labels: {[key: string]: any} = {}
        props?.keyMoments && props?.keyMoments?.length > 0 && props?.keyMoments?.map((moments: any, momentIndex: number) => {
            moments.keymoment_text.map((text: string) => {
                keyIsMomentValueisIndex[text] = momentIndex
            })
            // get keymoments labels too
            labels[moments.label] = moments.count
        })
        setKeyMomentsKeyIndex(keyIsMomentValueisIndex)
        setKeyMomentsLabels(labels)
    }

    const highlightMatchingText = (text: any) => {
        let matchRegex = RegExp(searchedInTranscript, 'ig');
        if(keyMomentsAction) {
            let keys = Object.keys(keyMomentsKeyIndex)
            // If both seach and keymoments has value then combine them and hightlight all
            if(searchedInTranscript.trim()) {
                keys[keys.length] = searchedInTranscript
            }
            keys = keys.map(key => {
                let k = escapeStringRegexp(key)
                return k
            })
            matchRegex = RegExp(keys.join('|'), 'ig')
        }
        // Matches array needed to maintain the correct letter casing
        const matches = [...text.matchAll(matchRegex)];
        if(!matches.length) {
            return text
        }

        return text
          .split(matchRegex)
          .map((nonBoldText: any, index:any, arr:any) => (
            <React.Fragment key={index}>
              <Linkify options={{target: '_blank'}}>{nonBoldText}</Linkify>
              {index + 1 !== arr.length && <mark style={{background: randomColor[keyMomentsKeyIndex[matches[index]]]}} >{matches[index]}</mark>}
            </React.Fragment>
        ));
    };

    const listKeyMomentsLabels = keyMomentsLabels && Object.keys(keyMomentsLabels) && Object.keys(keyMomentsLabels).length > 0 && Object.keys(keyMomentsLabels).map((label: any, i: number) => {
        return  <li className={styles.positiveSentiment}>
                    <span style={{backgroundColor: randomColor[i]}}></span>{label} {keyMomentsLabels[label] > 9 ? keyMomentsLabels[label] : `0${keyMomentsLabels[label]}`}
                </li>
    })

    const toggleSearch = () => {
        setSearchedInTranscript('')
        setActiveSearchBar(!activeSearchBar)
    }
    
    useEffect(() => {
        document.getElementById('search-bar')?.focus()
    }, [activeSearchBar])
    
    const chatTranscriptUI = props.transcript && props.transcript.length > 0 && props.transcript.map((transcript: {[key: string]: any}, i: number) => {
        let highlightTranscript = (props.curTime >= (transcript.start) && props.curTime <= (transcript.end)) ? styles.highlightTranscript : ''
        return  <li className={`transcript-${transcript.start}`} key={`transcript-${transcript.start}-${i}`}>
                    {
                            props.type === 'audio' ? 
                                <button type="button" className="btn btn-link col-2 text-decoration-none text-start" onClick={() => props.onTimeUpdate(transcript.start/1000)}>
                                    {moment.duration(transcript.start, "milliseconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"})} - {moment.duration(transcript.end, "milliseconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"})}
                                </button> :
                                <span className="btn btn-link col-1 text-decoration-none p-0 text-start">
                                    {moment.duration(transcript.start, "seconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"})}
                                </span>
                    }
                    <div className='col-11'>
                        <h6 className={`text-capitalize ${transcript.speaker_type.toLowerCase() == 'agent' ? styles.agentSpeaker : (transcript.speaker_type.toLowerCase() == 'customer' ? styles.customerSpeaker : styles.botSpeaker)}`}>
                            { transcript.speaker_name ? `${transcript.speaker_type} - ${transcript.speaker_name}` :  `${transcript.speaker_type} - ` }
                        </h6>
                        <p className={`${highlightTranscript}`}>
                            { 
                                (searchedInTranscript.trim() || keyMomentsAction) ?
                                    highlightMatchingText(transcript.text) :
                                    transcript.text
                            }
                        </p>
                        {
                            sentimentsAction && transcript.speaker_type == 'customer' ?
                                <ul className={`${styles.conversationSentiments} list-unstyled d-flex`}>
                                    { 
                                        parseInt(props.utterances[transcript.message_id].sentiment[`x_ssense_${transcript.speaker_type}_sentiment_overview_positive_count_v1`]) > 0 &&
                                        <span className={`${styles.positiveHighlight} ${styles.sentimentHighlight}`}></span>                                
                                    }
                                    { 
                                        parseInt(props.utterances[transcript.message_id].sentiment[`x_ssense_${transcript.speaker_type}_sentiment_overview_negative_count_v1`]) > 0 &&
                                        <span className={`${styles.negativeHighlight} ${styles.sentimentHighlight}`}></span>                                
                                    }
                                </ul> :
                                null
                        }
                    </div>
                </li>
    })

    const emailTranscriptUI = props.transcript && props.transcript.length > 0 && props.transcript.map((transcript: {[key: string]: any}, i: number) => {
        let highlightTranscript = (props.curTime >= (transcript.start) && props.curTime <= (transcript.end)) ? styles.highlightTranscript : ''
        return  <li className={`p-3 d-block ${styles.emailBorder} ${styles.emailSessionContainer} mb-2`} key={`email-transcript-${transcript.start}-${i}`}>
                    <div className={`${styles.userDetails} d-flex align-items-center justify-content-between position-relative pe-4 email-header collapsed`} data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapse-${i}`} aria-expanded="true" aria-controls={`#panelsStayOpen-collapse-${i}`}>
                        <b>{ transcript.speaker_name ? `${transcript.speaker_type} - ${transcript.speaker_name}` :  `${transcript.speaker_type} - ` }</b>
                        <span className={`${styles.createdAt}`}>
                        {moment.tz(transcript?.date_time, "UTC").format('MMMM D, YYYY  h:mm A z')}
                        </span>                            
                    </div>                                                             
                    <div className={`mt-3 ${styles.conversationContent} accordion-collapse collapse`} id={`panelsStayOpen-collapse-${i}`} aria-labelledby={`panelsStayOpen-collapse-${i}`}>
                        <p className={`${highlightTranscript}`}>
                            { 
                                (searchedInTranscript.trim() || keyMomentsAction) ?
                                    highlightMatchingText(transcript.text) :
                                    <Linkify options={{target: '_blank'}}>{transcript.text}</Linkify>
                            }
                        </p>
                        {
                            sentimentsAction && transcript.speaker_type == 'customer' ?
                                <ul className={`${styles.conversationSentiments} list-unstyled d-flex`}>
                                    { 
                                        parseInt(props.utterances[transcript.message_id].sentiment[`x_ssense_${transcript.speaker_type}_sentiment_overview_positive_count_v1`]) > 0 &&
                                        <span className={`${styles.positiveHighlight} ${styles.sentimentHighlight}`}></span>                                
                                    }
                                    { 
                                        parseInt(props.utterances[transcript.message_id].sentiment[`x_ssense_${transcript.speaker_type}_sentiment_overview_negative_count_v1`]) > 0 &&
                                        <span className={`${styles.negativeHighlight} ${styles.sentimentHighlight}`}></span>                                
                                    }
                                </ul> :
                                null
                        }
                    </div>
                </li>
    })

    return (
        <div className={styles.transcriptSection}>
                <div>
                    <div className='d-flex justify-content-between'>
                        <h6 className={styles.title}>{props.type == 'email' ? 'Email' : 'Transcript'}</h6>
                        <div className='d-flex'>
                            <div className={`d-flex align-items-center me-2 ${styles.search} ${activeSearchBar ? styles.active : '' }`}>
                                {
                                    activeSearchBar && <input id="search-bar" type="text" value={searchedInTranscript} onChange={(e) => setSearchedInTranscript(e?.target?.value)} />
                                }
                                <img alt="Search" title="Search" onClick={toggleSearch} src={searchIcon} />
                            </div>
                            <ul className={`${styles.transcriptActions} list-unstyled d-flex m-0`}>  
                                <li title="Key moments" onClick={() => props.keyMoments && props.keyMoments.length > 0 && setKeyMomentsAction(!keyMomentsAction)} className={`${props.keyMoments && props.keyMoments.length > 0 ? '' : styles.disabled} ${styles.keymoments} ${keyMomentsAction ? styles.active : '' }`}>
                                    <img src={keyMomentsAction ? keymomentsIconActive : keymomentsIcon} />
                                </li>
                                <li title="Sentiments" onClick={() => totalSentimentsCount > 0 && setSentimentsAction(!sentimentsAction)} className={`${totalSentimentsCount > 0 ? '' : styles.disabled} ${styles.sentiments} ${sentimentsAction ? styles.active : '' }`}>
                                    <img src={sentimentsAction ? sentimentIconActive : sentimentIcon} />
                                </li>
                            </ul>
                        </div>                        
                    </div>
                    {
                        sentimentsAction ? 
                            <ul className={`${styles.sentimentsStack} list-unstyled d-flex`}>
                                { 
                                    props.totalSentiments.positiveSentiments > 0 &&
                                    <li className={styles.positiveSentiment}>Positive {props.totalSentiments.positiveSentiments > 9 ? props.totalSentiments.positiveSentiments : `0${props.totalSentiments.positiveSentiments}`}</li>
                                }
                                { 
                                    props.totalSentiments.negativeSentiments > 0 &&
                                    <li className={styles.negativeSentiment}>Negative {props.totalSentiments.negativeSentiments > 9 ? props.totalSentiments.negativeSentiments : `0${props.totalSentiments.negativeSentiments}`}</li>
                                }
                            </ul> :
                            null
                    }
                    {
                        keyMomentsAction ?
                            <ul className={`${styles.labelsStack} list-unstyled d-flex`}>
                                {listKeyMomentsLabels}
                            </ul> :
                            null
                    }
                </div>
                <ul className={`${styles.transcriptContainer}`}>
                {
                    props.type == 'chat' || props.type == 'call' ?
                        chatTranscriptUI :
                        (
                            props.type == 'email' ?
                                <>
                                    {/* <div className={`text-center py-2 mt-3 mb-1 ${`${styles.emailBorder}`}`}>
                                        <b>Subject</b>: <span>Cancel order Not getting it in time and not able to connect with anyone to get an update</span>
                                    </div> */}
                                    <ul className={`${styles.conversationBlocks} p-0 mt-3`}>
                                        {emailTranscriptUI.reverse()}
                                    </ul>
                                </> :
                                null
                        )
                }
                </ul>
        </div>
    )
}

export default Transcript
